"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isSearchableBuilder = function isSearchableBuilder() {
  return 'isSearchable:true';
};

var _default = isSearchableBuilder;
exports["default"] = _default;